import React, { useState, useEffect } from 'react';

import Login from '../Login';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import {onlineHubHost} from '../../config';

import './App.css';

function App() {
  const [loginSuccess, setLoginSuccess] = useState(null);

  useEffect(() => {
    fetch(`${onlineHubHost}/app/devices`, {
      method: 'get',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'content-type': 'application/json'
      },
    })
    .then((res) => {
      setLoginSuccess(res.ok);
    })
  }, []);

  function handleLogOut() {
    setLoginSuccess(false);
    localStorage.removeItem('token');
  }

  if (loginSuccess === null) {
    return null;
  }

  return (
    <div className="App">
      {loginSuccess ?
        <MainLayout onLogOut={handleLogOut} />
      : <Login onSuccess={setLoginSuccess} />}
    </div>
  );
}

export default App;
